import React from "react";
import styles from "./FeedbackButoon.module.css";

const FeedbackButton = ({ setOpen }) => {
  const handleClick = () => {
    setOpen(true);
  };

  return (
    <div className={styles.feedbackContainer} onClick={handleClick}>
      <div className={styles.feedbackButton}>
        <span>Feedback</span>
      </div>
    </div>
  );
};

export default FeedbackButton;
